// src/components/alerts/AlertPerformanceDrawer.js
// --- UPDATE (Alert System AI) — moved out of AlertSystemPage (development only). Shows the
// client render count and the server's FlowSense AI compute time.
import React from 'react';
import PropTypes from 'prop-types';
import {
    Alert, AlertDescription, AlertIcon, Box, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader,
    DrawerOverlay, HStack, Icon, SimpleGrid, Text, useColorModeValue,
} from '@chakra-ui/react';
import { MdBarChart } from 'react-icons/md';

function AlertPerformanceDrawer({ isOpen, onClose, metrics }) {
    const border = useColorModeValue('gray.100', 'gray.700');
    return (
        <Drawer isOpen={isOpen} onClose={onClose} placement="right" size="sm">
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader borderBottomWidth="1px" borderColor={border}>
                    <HStack><Icon as={MdBarChart} color="purple.500" /><Text>Performance</Text></HStack>
                </DrawerHeader>
                <DrawerBody py={4}>
                    <SimpleGrid columns={2} spacing={3}>
                        {Object.entries(metrics || {}).map(([k, v]) => (
                            <Box key={k} p={3} borderRadius="lg" borderWidth="1px" borderColor={border}>
                                <Text fontSize="10px" color="gray.500" fontWeight="700" textTransform="uppercase">{k.replace(/_/g, ' ')}</Text>
                                <Text fontSize="xl" fontWeight="800" color="purple.500">{v ?? '—'}</Text>
                            </Box>
                        ))}
                    </SimpleGrid>
                    <Alert status="info" borderRadius="lg" mt={4}><AlertIcon /><AlertDescription fontSize="xs">Shown in development builds only.</AlertDescription></Alert>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    );
}

AlertPerformanceDrawer.propTypes = { isOpen: PropTypes.bool.isRequired, onClose: PropTypes.func.isRequired, metrics: PropTypes.object };

export default AlertPerformanceDrawer;
// --- END UPDATE
